<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MeetingsModalDesktop',
  computed: {
    ...mapGetters({
      meetings: 'FormGuideMeetingHeader/getMeetingsData',
    }),
    meetingsGroup() {
      return this.meetings || [];
    },
  },
  methods: {
    updateMeeting(slug) {
      this.$emit('updateMeetingSlug', slug);
    },
  },
};
</script>

<template>
  <div class="meetings-modal-desktop">
    <div class="meetings-modal-desktop__container">
      <template v-for="(group, meetingDate) in meetingsGroup">
        <div :key="group.value" class="meetings-modal-desktop__meeting-date">
          {{ meetingDate }}
          <div class="meetings-modal-desktop__meeting-group">
            <template v-for="(meeting, index) in group">
              <a
                :key="index"
                :href="`${meeting.slug}`"
                class="meetings-modal-desktop__meeting-name"
                @click.prevent="updateMeeting(meeting.slug)"
              >{{ meeting.name }}</a>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
